const state = {
  ppob_transactions: [],
  ppob_transaction: {},
};

export default state;
